export default function() {
  'ngInject';

  function statusClasses(text, assigned) {
    if (text === 'Enrolled') return 'label-success badge-success';

    if (text === 'Started') return 'label-warning badge-warning';
    if (text === 'In Progress') return 'label-warning badge-warning';
    if (text === 'Final') return 'label-warning badge-warning';

    if (text === 'Completed') return 'label-primary badge-primary';
    if (text === 'Reviewed') return 'label-primary badge-primary';

    if (assigned) return 'label-success badge-success';

    return 'label-default badge-default';
  }

  function getText(text, assigned) {
    if (text === 'Enrolled') return 'In Progress';
    if (text === 'Started') return 'In Progress';

    if (text === 'In Progress') return 'In Progress';
    if (text === 'Final') return 'In Progress';

    if (text === 'Completed') return 'Completed';
    if (text === 'Reviewed') return 'Completed';
    if (assigned) return 'Assigned';
    return 'Register';
  }

  return {
    restrict: 'A',
    scope: {
      status: '<',
      assigned: '<'
    },
    link: function(scope, element) {
      const color = statusClasses(scope.status, scope.assigned);
      const text = getText(scope.status, scope.assigned);

      element.addClass(color);
      element[0].innerHTML = text;
    }
  };
}



// WEBPACK FOOTER //
// ./src/app/directives/courseStatusLabel/index.js